import Vue from 'vue'
import { Component, Emit, Prop, Watch } from 'vue-property-decorator'

@Component
export default class WorkoutActiveLoaderComponent extends Vue {
    @Emit('onCancel')
    onCancel() {
        return 0
    }
}